
export default {
  props: ["element"],
  name: "hyperCoreEmbed",
  data() {
    return {
    };
  },
};
